module.exports = __webpack_public_path__ + "img/vuma-community-icon.91ea14e0.svg";